module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar-large",
    staticStyle: {
      "margin-top": "5em",
      "margin-left": "-2em",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "bottombar"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "none",
      "width": "22%"
    },
    attrs: {
      "id": "a_store",
      "href": _vm.set_store_url
    }
  }, [_c('i', {
    staticClass: "fas fa-store-alt",
    attrs: {
      "id": "m_store"
    }
  }), _c('br'), _c('span', [_vm._v("Store")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/placed/orders"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-basket",
    attrs: {
      "id": "m_orders"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Orders")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/placed/orders"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-basket",
    attrs: {
      "id": "m_orders"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Deals")])]), _vm._v(" "), _vm._m(6)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Feeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "a_home",
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fas fa-store-alt",
    attrs: {
      "id": "m_home"
    }
  }), _c('br'), _c('span', [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "display": "none",
      "width": "14%"
    },
    attrs: {
      "id": "a_search",
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fas fa-search",
    attrs: {
      "id": "m_search"
    }
  }), _c('br'), _c('span', [_vm._v("Search")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/settings"
    }
  }, [_c('i', {
    staticClass: "fas fa-cog",
    attrs: {
      "id": "m_settings"
    }
  }), _c('br'), _c('span', [_vm._v("Settings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d85a698"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/menubottom.vue
// module id = 610
// module chunks = 0